import React, { useContext } from 'react'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import authCaller from '../interceptor/auth'
import loanCaller from '../interceptor/loan'
import SupportCaller from '../interceptor/support'
import loanRepaymentCaller from '../interceptor/loanRepayment'
import walletCaller from '../interceptor/wallet'
import notificationCaller from '../interceptor/notification'
import { catchErrMsg, erroMessage, requestMessage, loglite } from 'src/utils/utility'
import { AuthModel, IDispute_ServiceLog, IPasswordReset } from 'src/model'
import { appSettings } from 'src/provider/config/constant'


const ApiContext = React.createContext<any>(null)

export const ApiProvider = (props: any) => {
    const {loader, notifier} = useContext(VisibilityContext)
    const {setInfoProperty, info, logout} = useContext(AppInfoContext)
    const {setUserProperty, user} = useContext(UserContext)
   
    async function login (payload?: AuthModel) {
        try {
            loader(true)
            const {data} = await authCaller.post('InitiateLogin', payload)
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                await setUserProperty('userInfo', {...user.userInfo, ...data.data})
                notifier.show(data.message || 'Otp has been sent to your email', null, 'success')
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }
    
    async function completeLogin (otp: string) {
        try {
            loader(true)
            const {data} = await authCaller.post('CompleteLogin', {
                otp,
                userId: user.userInfo?.userId
            })
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                await setUserProperty('userInfo', {...user.userInfo, ...data.data})
                setInfoProperty('token', data.data?.accessToken)
                setInfoProperty('refreshToken', data.data?.refreshToken)
                return true
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function initiatePasswordReset (email: string) {
        try {
            loader(true)
            const {data} = await authCaller.post('ForgotPassword', {email})
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                await setUserProperty('userInfo', {...user.userInfo, ...data.data, email})
                notifier.show(data.message || 'Otp has been sent to your email', null, 'success')
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function resetPassword (payload?: IPasswordReset) {
        try {
            loader(true)
            const {data} = await authCaller.post('ResetPassword', {
                ...payload,
                otp: info.passwordResetOtp,
                userId: user.userInfo.userId
            })
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                notifier.show(data.message || 'Password Reset Successful', null, 'success')
                return true
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function resendLoginOtp (userId?: string) {
        try {
            loader(true)
            const {data} = await authCaller.get(`ResendOTP/${userId || user.userInfo?.userId}`)
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                await setUserProperty('userInfo', {...user.userInfo, ...data.data})
                notifier.show(data.message || 'Otp has been sent to your email', null, 'success')
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getUserStats (payload?: any) {
        try {
            loader(true)
            const {data} = await authCaller.get('GetUserStat', {
                params: {
                    StartDate: payload?.startDate, 
                    EndDate: payload?.endDate
                }
            })
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                await setInfoProperty('userStats', data.data)
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function searchUser (searchParam: string) {
        try {
            loader(true)
            const {data} = await authCaller.get(`GetUserInfo/${searchParam}`)
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                await setInfoProperty('searchedUserInfo', data.data)
                return data.status
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getTransactionHistoryByDate (payload: any) {
        try {
            loader(true)
            const {data} = await walletCaller.post(`Admin/GetTransactionsHistoryByDateRange`, {
                ...payload,
                customerId: info.searchedUserInfo?.customerId //'0041179457'
            })
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                await setInfoProperty('searchedUserTx', data.data)
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            console.log({err})
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getLoginHistories () {
        try {
            loader(true)
            const {data} = await authCaller.get(`GetLoginHistoriesForUser/${info.searchedUserInfo?.customerId}`)
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            console.log({err})
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getLendingActivities () {
        try {
            loader(true)
            const {data} = await loanCaller.get(`Admin/GetLendingInfo/${info.searchedUserInfo?.customerId}`)
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            console.log({err})
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getBorrowingActivities () {
        try {
            loader(true)
            const {data} = await loanCaller.get(`Admin/GetBorrowingInfo/${info.searchedUserInfo?.customerId}`)
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                return data.data
            }
        }
        catch (err: any) {
            loader(false) 
            console.log({err})
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function generatePasswordResetLinkForUser () {
        try {
            loader(true)
            const {data} = await authCaller.get(`GenerateResetPasswordLinkForUser/${info.searchedUserInfo?.userId}`)
            loader(false)

            console.log({response: data})
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data.status
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getServiceRequestsAndDisputes (dateOpenned?: string) {
        try {
            loader(true)
            const {data} = await SupportCaller.get(`DisputeAndRequest/GetAllServiceRequestsAndDisputes`, {
                params: {
                    dateOpenned
                }
            })
            loader(false)

            loglite(data, 'getServiceRequestsAndDisputes')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data.data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }


    async function getDisputes (dateOpenned?: string) {
        try {
            loader(true)
            const {data} = await SupportCaller.get(`DisputeAndRequest/GetAllDisputes`, {
                params: {
                    dateOpenned
                }
            })
            loader(false)

            loglite(data, 'getDisputes')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data.data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }


    async function getServiceRequests (dateOpenned?: string) {
        try {
            loader(true)
            const {data} = await SupportCaller.get(`DisputeAndRequest/GetServiceRequests`, {
                params: {
                    dateOpenned
                }
            })
            loader(false)

            loglite(data, 'getServiceRequests')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data.data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function logServiceRequestOrDispute (payload: IDispute_ServiceLog) {
        try {
            loader(true)
            const {data} = await SupportCaller.post(`DisputeAndRequest/LogServiceRequestOrDistpute`, {...payload})
            loader(false)

            loglite(data, 'logServiceRequestOrDispute API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else {
                notifier.show(data.message || 'Service Request / Dispute Successfully Logged', null, 'success')
                return true
            }
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function changeDisputeOrRequestStatus (id: number, status: string) {
        try {
            loader(true)
            const {data} = await SupportCaller.put(`DisputeAndRequest/ResolveOrUnresolveIssue/${id}`, {status})
            loader(false)

            loglite(data, 'changeDisputeOrRequestStatus API')
            if (!data.status) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function refreshToken (shouldTriggerRefresh = true) {
        try {
            loader(true)
            const {status, data} = await authCaller.post(`refresh_token`, {
                accessToken: info.token,
                refreshToken: info.refreshToken
            })
            loader(false)

            loglite(data, 'refreshTtoken')
            if ((status != 200 && status != 201) || !data.status) {
                logout()
            }
            else {
                await setInfoProperty('refreshToken', data.data?.refreshToken)
                await setInfoProperty('token', data.data?.accessToken)
                if (shouldTriggerRefresh) await setInfoProperty('refreshTokenTrigger', !info.refreshTokenTrigger)
                return true
            }
        }
        catch (err: any) {
            loader(false)
            logout()
        }
    }

    async function getAllCustomers (PageNumber: number, PageSize: string) {
        try {
            loader(true)
            const {status, data} = await authCaller.get(`GetAllUsers`, {
                params: {PageNumber, PageSize}
            })
            loader(false)

            loglite(data, 'getAllCustomers API')
            if ((status != 200 && status != 201)) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAllPortfolios (PageNumber: number, PageSize: string) {
        try {
            loader(true)
            const {status, data} = await loanCaller.get(`Admin/GetAllLoanOffers`, {
                params: {PageNumber, PageSize}
            })
            loader(false)

            loglite(data, 'getAllPortfolios API')
            if ((status != 200 && status != 201)) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data.data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAllLoanRequests (PageNumber: number, PageSize: string) {
        try {
            loader(true)
            const {status, data} = await loanCaller.get(`Admin/GetAllLoanRequests`, {
                params: {PageNumber, PageSize}
            })
            loader(false)

            loglite(data, 'getAllLoanRequests API')
            if ((status != 200 && status != 201)) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data.data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getAllTransactions (pageNumber: number, pageSize: string) {
        try {
            loader(true)
            const {status, data} = await walletCaller.get(`Admin/GetAllTransactions`, {
                params: {pageNumber, pageSize}
            })
            loader(false)

            loglite(data, 'getAllTransactions API')
            if ((status != 200 && status != 201)) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function getErrorLogs (PageNumber: number, PageSize: string, payload = {}) {
        try {
            loader(true)
            const {status, data} = await SupportCaller.get(`ErrorAndActivityLogy/GetErrorLogs`, {
                params: {PageNumber, PageSize, ...payload}
            })
            loader(false)

            loglite(data, 'getErrorLogs API')
            if ((status != 200 && status != 201)) {
                notifier.show(requestMessage(data))
                return null
            }
            else return data
        }
        catch (err: any) {
            loader(false) 
            notifier.show(erroMessage(catchErrMsg(err)))
            return null
        }
    }

    async function runBackgroundJob (type: string | Array<string>, waitTime = appSettings.BACKGROUND_JOB_WAIT_TIME) {
        try {
            if (typeof type === 'string') type = [type]

            for (let service of type) {
                await wait(waitTime)
                console.log({currentBackgroundJob: service})
                if (service === 'get-refresh-token') await refreshToken()
            }
        }
        catch (err) {
            console.log({backgroundService: err})
        }
    }

    const wait = (time: number) => new Promise(res => setTimeout(res, time))

    const callActions = {
        login,
        completeLogin,
        initiatePasswordReset,
        resetPassword,
        resendLoginOtp,
        getUserStats,
        searchUser,
        getTransactionHistoryByDate,
        getLoginHistories,
        getLendingActivities,
        getBorrowingActivities,
        generatePasswordResetLinkForUser,
        getServiceRequestsAndDisputes,
        getDisputes,
        getServiceRequests,
        logServiceRequestOrDispute,
        changeDisputeOrRequestStatus,
        getAllCustomers,
        runBackgroundJob,
        getAllPortfolios,
        getAllLoanRequests,
        getAllTransactions,
        getErrorLogs
    }

    return (
        <ApiContext.Provider value={{API: callActions}} >
            {props.children}
        </ApiContext.Provider>
    )
}

export default ApiContext